import { useSnackbar as useNotistackSnackbar } from "notistack";
import { useMemo } from "react";

const noop = () => {};

export const useSnackbar = () => {
  const notistackSnackbar = useNotistackSnackbar();
  return useMemo(
    () => ({
      enqueueSnackbar: notistackSnackbar?.enqueueSnackbar || noop,
      closeSnackbar: notistackSnackbar?.closeSnackbar || noop,
    }),
    [notistackSnackbar]
  );
};
